import { Disease } from '@/types'

export const dogDiseases: Disease[] = [
  {
    id: 'kopek-yalama',
    title: 'Köpekler Neden Sahibini Yalar?',
    category: 'dog',
    slug: 'kopekler-neden-sahibini-yalar',
    content: 'Yalama; iletişim, bağ kurma, keşfetme ve pekişmiş öğrenme (ödüllenmiş davranış) gibi nedenlerle ortaya çıkan doğal bir davranıştır. Aşırıya kaçması stres, anksiyete veya dermatolojik sorunların işareti olabilir.\n\nYönlendirme, zenginleştirme ve pozitif eğitimle azaltılabilir; altta yatan tıbbi durum şüphesinde veteriner değerlendirmesi gerekir.',
    symptoms: ['Aşırı yalama', 'Nesne/deri yalama'],
    treatment: ['Pozitif eğitim', 'Zenginleştirme'],
    prevention: ['Düzenli egzersiz', 'Rutin']
  },
  {
    id: 'dcm',
    title: 'Köpeklerde Dilate Kardiyomiyopati (DCM): Teşhisi, Tedavisi ve Sebepleri',
    category: 'dog',
    slug: 'kopeklerde-dilate-kardiyomiyopati',
    content: 'DCM; kalp kasının genişleyip kasılma gücünün azalmasıyla egzersiz intoleransı, öksürük ve nefes darlığına yol açar. Tanıda eko ve EKG kullanılır.\n\nTedavide ACE inhibitörleri, pimobendan ve diüretikler; diyet ve kardiyoloji takibi esastır.',
    symptoms: ['Nefes darlığı', 'Yorgunluk', 'Öksürük'],
    treatment: ['Pimobendan', 'ACE inhibitörü', 'Diüretik'],
    prevention: ['Tarama', 'Dengeli diyet']
  },
  {
    id: 'deri-kanseri',
    title: 'Köpeklerde Deri Kanseri: Sebepleri ve Tedavisi',
    category: 'dog',
    slug: 'kopeklerde-deri-kanseri',
    content: 'Mast hücre tümörü, SCC ve melanoma gibi birçok cilt tümörü köpeklerde görülür. Erken fark edilen kitleler başarıyla tedavi edilebilir.\n\nTanı biyopsi ile konur; tedavi cerrahiye, gerektiğinde kemoterapi/radyoterapiye dayanır.',
    symptoms: ['Yeni/büyüyen kitle', 'Renk değişimi'],
    treatment: ['Cerrahi', 'Onkolojik tedaviler'],
    prevention: ['Düzenli cilt kontrolü', 'Güneşten korunma']
  },
  {
    id: 'kopeklerde-pire',
    title: 'Köpeklerde Pire: Teşhisi, Tedavisi & Sebepleri',
    category: 'dog',
    slug: 'kopeklerde-pire',
    content: 'Pireler kaşıntı, FAD (pire alerjisi dermatiti) ve anemiye neden olabilir. Ev döngüsü nedeniyle tekrarlar gözlenir.\n\nTedavi; güvenli topikal/oral pire ürünleri ve çevresel temizlik; aylık profilaksi esastır.',
    symptoms: ['Kaşıntı', 'Kabuklanma', 'Kıl dökülmesi'],
    treatment: ['Topikal/oral pire ürünleri', 'Çevresel mücadele'],
    prevention: ['Aylık profilaksi', 'Ev hijyeni']
  },
  {
    id: 'kopeklerde-lupus',
    title: 'Köpeklerde Lupus: Sebepleri, Belirtileri ve Tedavisi',
    category: 'dog',
    slug: 'kopeklerde-lupus',
    content: 'Lupus; bağışıklık sisteminin kendi dokularına saldırdığı otoimmün bir hastalıktır. Diskoid form daha çok burun-deri lezyonları, sistemik form çoklu organ tutulumu yapar.\n\nTedavi; immünmodülasyon (kortikosteroid/diğer), güneşten korunma ve sekonder enfeksiyon yönetimini içerir.',
    symptoms: ['Burunda yara', 'Deride kabuk', 'Letarji'],
    treatment: ['Kortikosteroid', 'İmmünsüpresifler'],
    prevention: ['Güneşten korunma']
  },
  {
    id: 'kalp-kurdu',
    title: 'Köpeklerde Kalp Kurdu: Teşhisi, Tedavisi ve Sebepleri',
    category: 'dog',
    slug: 'kopeklerde-kalp-kurdu',
    content: 'Dirofilaria immitis sivrisineklerle bulaşır; öksürük, egzersiz intoleransı ve kilo kaybı görülebilir.\n\nTanı antijen testleri ve görüntüleme ile; tedavi yetişkinicid protokoller ve profilaksiye dayanır.',
    symptoms: ['Öksürük', 'Egzersiz intoleransı'],
    treatment: ['Yetişkinicid tedavi', 'Destek'],
    prevention: ['Aylık profilaksi', 'Vektör kontrolü']
  },
  {
    id: 'kalca-cikigi',
    title: 'Köpeklerde Kalça Çıkığı: Teşhisi, Tedavisi ve Sebepleri',
    category: 'dog',
    slug: 'kopeklerde-kalca-cikigi',
    content: 'Travma veya displazi zemininde femurun asetabulumdan çıkmasıdır. Şiddetli topallık ve ağrı yapar.\n\nTedavi; kapalı redüksiyon/immobilizasyon veya cerrahi yöntemleri içerir.',
    symptoms: ['Şiddetli topallık', 'Ağrı'],
    treatment: ['Redüksiyon', 'Cerrahi'],
    prevention: ['Travma önleme', 'Displazi taraması']
  },
  {
    id: 'kopeklerde-iyes',
    title: 'Köpeklerde İdrar Yolu Enfeksiyonu: Nedenleri ve Tedavi Süreci',
    category: 'dog',
    slug: 'kopeklerde-idrar-yolu-enfeksiyonu',
    content: 'İYE; sık ve ağrılı idrar, bazen kanla seyreder. Bakteriyel enfeksiyonlar ve taş/kristaller eşlik edebilir.\n\nTedavi kültüre göre antibiyotik, ağrı kontrolü ve diyet düzenlemesini içerir.',
    symptoms: ['Sık idrar', 'Zorlanma', 'Kanlı idrar'],
    treatment: ['Antibiyotik', 'Ağrı kontrolü', 'Diyet'],
    prevention: ['Su tüketimi', 'Uygun diyet']
  },
  {
    id: 'kulak-enfeksiyonu',
    title: 'Köpeklerde Kulak Enfeksiyonu',
    category: 'dog',
    slug: 'kopeklerde-kulak-enfeksiyonu',
    content: 'Otitis externa; kaşıntı, kızarıklık ve kötü kokulu akıntı ile seyreder. Alerji, nem ve anatomik yatkınlık risk faktörleridir.\n\nTedavi; temizlik, topikal/ortal damlalar ve altta yatan nedenin kontrolünü içerir.',
    symptoms: ['Kulak kaşıma', 'Koku', 'Akıntı'],
    treatment: ['Kulak temizliği', 'Antibiyotik/antifungal damla'],
    prevention: ['Kulak kuruluğu', 'Alerji kontrolü']
  },
  {
    id: 'goz-akintisi-capak',
    title: 'Köpeklerde Göz Akıntısı ve Çapaklanması',
    category: 'dog',
    slug: 'kopeklerde-goz-akintisi-ve-capaklanmasi',
    content: 'Alerji, irritasyon, enfeksiyon veya anatomik yatkınlık akıntıya yol açabilir. Akıntının türü ve eşlik eden bulgular tanıda yol gösterir.\n\nTedavi; altta yatan nedene göre damlalar ve çevresel düzenlemeyi içerir.',
    symptoms: ['Akıntı', 'Kızarıklık'],
    treatment: ['Göz damlaları', 'Temizlik'],
    prevention: ['Toz/dumandan kaçınma']
  },
  {
    id: 'distemper',
    title: 'Köpeklerde Distemper (Gençlik Hastalığı)',
    category: 'dog',
    slug: 'kopeklerde-distemper',
    content: 'Solunum, gastrointestinal ve sinir sistemini etkileyen ciddi viral hastalık.\n\nDestekleyici tedavi ve aşılama esastır.',
    symptoms: ['Ateş', 'Burun-göz akıntısı', 'Öksürük'],
    treatment: ['Destekleyici bakım'],
    prevention: ['Aşılama']
  },
  {
    id: 'egzama',
    title: 'Köpeklerde Egzama',
    category: 'dog',
    slug: 'kopeklerde-egzama',
    content: 'Atopik dermatit alerjenlere bağlı kaşıntı ve deri lezyonlarıyla seyreder.\n\nTedavi; antipruritikler, immünoterapi ve bariyer bakımıdır.',
    symptoms: ['Kaşıntı', 'Kızarıklık'],
    treatment: ['Antihistaminik', 'Steroid/biolojik'],
    prevention: ['Alerjen azaltımı']
  },
  {
    id: 'hipotiroidizm',
    title: 'Köpeklerde Hipotiroidizm',
    category: 'dog',
    slug: 'kopeklerde-hipotiroidizm',
    content: 'Tiroid hormon eksikliği; kilo alma, halsizlik ve tüy dökülmesiyle seyreder.\n\nTedavi ömür boyu levotiroksin replasmanıdır.',
    symptoms: ['Kilo artışı', 'Letarji', 'Tüy dökülmesi'],
    treatment: ['Levotiroksin'],
    prevention: ['Düzenli kontrol']
  },
  {
    id: 'barinak-hastaligi',
    title: 'Köpeklerde Barınak Hastalığı',
    category: 'dog',
    slug: 'kopeklerde-barinak-hastaligi',
    content: 'Kennel cough; kuru öksürük ve hırıltıyla seyreder, kalabalık ortamlarda yaygındır.\n\nSemptomatik destek ve aşı korunmada etkilidir.',
    symptoms: ['Kuru öksürük', 'Hırıltı'],
    treatment: ['Öksürük baskılayıcı', 'Gerekirse antibiyotik'],
    prevention: ['Aşılama', 'Havalandırma']
  },
  {
    id: 'eklem-agrisi',
    title: 'Köpeklerde Eklem Ağrısı',
    category: 'dog',
    slug: 'kopeklerde-eklem-agrisi',
    content: 'Osteoartrit sık nedendir; topallık ve mobilite azalır.\n\nAğrı yönetimi, kilo kontrolü ve eklem destekleri temel yaklaşımdır.',
    symptoms: ['Topallık', 'Zor kalkma'],
    treatment: ['NSAID', 'Fizyoterapi'],
    prevention: ['Kilo yönetimi', 'Uygun egzersiz']
  },
  {
    id: 'ishal',
    title: 'Köpeklerde İshal',
    category: 'dog',
    slug: 'kopeklerde-ishal',
    content: 'Diyet, parazit veya viral nedenlerle sık/sulu dışkı oluşur.\n\nDiyet düzenlemesi, probiyotik ve gerekirse ilaçlarla tedavi edilir.',
    symptoms: ['Sulu dışkı', 'Karın gurultusu'],
    treatment: ['Diyet', 'Probiyotik'],
    prevention: ['Parazit kontrolü']
  },
  {
    id: 'istahsizlik',
    title: 'Köpeklerde İştahsızlık',
    category: 'dog',
    slug: 'kopeklerde-istahsizlik',
    content: 'Akut/kronik hastalıklar, ağrı veya stres iştahı azaltabilir.\n\nNedene yönelik tedavi ve beslenme desteği uygulanır.',
    symptoms: ['Yem yememe', 'Kilo kaybı'],
    treatment: ['Nedene yönelik'],
    prevention: ['Rutin kontrol']
  },
  {
    id: 'ehrlichiosis',
    title: 'Köpeklerde Kan Paraziti (Ehrlichiosis)',
    category: 'dog',
    slug: 'kopeklerde-ehrlichiosis',
    content: 'Kene kaynaklı; ateş, letarji ve kanama eğilimi yapabilir.\n\nTedavi uygun antibiyotik ve destek bakımdır.',
    symptoms: ['Ateş', 'Letarji', 'Morarma'],
    treatment: ['Doksisiklin'],
    prevention: ['Kene koruması']
  },
  {
    id: 'kanli-ishal',
    title: 'Köpeklerde Kanlı İshal',
    category: 'dog',
    slug: 'kopeklerde-kanli-ishal',
    content: 'Hemorajik gastroenterit, parvo veya parazitler neden olabilir.\n\nSıvı tedavisi ve nedene yönelik yaklaşım şarttır.',
    symptoms: ['Kanlı dışkı', 'Letarji'],
    treatment: ['Sıvı-elektrolit', 'Nedene yönelik'],
    prevention: ['Aşılama', 'Parazit kontrol']
  },
  {
    id: 'kuduz',
    title: 'Köpeklerde Kuduz',
    category: 'dog',
    slug: 'kopeklerde-kuduz',
    content: 'Zoonotik ve ölümcül; davranış değişimi ve felç yapar.\n\nTek korunma yolu aşı ve temas sonrası profilaksidir.',
    symptoms: ['Agresyon', 'Felç'],
    treatment: ['Yasal prosedür'],
    prevention: ['Aşılama']
  },
  {
    id: 'oksuruk',
    title: 'Köpeklerde Öksürük',
    category: 'dog',
    slug: 'kopeklerde-oksuruk',
    content: 'ÜSYE, trakeal kollaps veya kalp hastalığı gibi çoklu nedenler öksürük yapabilir.\n\nTanı ile nedene yönelik tedavi planlanır.',
    symptoms: ['Kuru/ıslak öksürük'],
    treatment: ['Nedene yönelik'],
    prevention: ['Aşılama', 'Alerjen azaltımı']
  },
  {
    id: 'yuksek-ates',
    title: 'Köpeklerde Yüksek Ateş',
    category: 'dog',
    slug: 'kopeklerde-yuksek-ates',
    content: 'Ateş enfeksiyon/inflamasyon göstergesidir.\n\nVeteriner değerlendirmesi ve nedene yönelik tedavi gerekir.',
    symptoms: ['Yüksek ısı', 'Halsizlik'],
    treatment: ['Sıvı desteği', 'Nedene yönelik'],
    prevention: ['Aşılama', 'Parazit kontrol']
  },
  {
    id: 'leishmaniasis',
    title: 'Leishmaniasis',
    category: 'dog',
    slug: 'leishmaniasis',
    content: 'Vektörle bulaşan; deri lezyonları, kilo kaybı ve lenfadenopatiyle seyreder.\n\nTedavi antiprotozoal protokoller ve vektör mücadelesidir.',
    symptoms: ['Deri lezyonları', 'Kilo kaybı'],
    treatment: ['Antiprotozoal tedavi'],
    prevention: ['Vektör kontrolü']
  },
  {
    id: 'leptospiroz',
    title: 'Leptospiroz',
    category: 'dog',
    slug: 'leptospiroz',
    content: 'Leptospira bakterisiyle bulaşan zoonotik hastalık; ateş, sarılık ve böbrek-karaciğer hasarı yapabilir.\n\nAşılama ve rodent kontrolü korunmada önemlidir.',
    symptoms: ['Ateş', 'Sarılık'],
    treatment: ['Antibiyotik', 'Destek bakımı'],
    prevention: ['Aşılama', 'Kemirgen kontrolü']
  },
  {
    id: 'lyme',
    title: 'Lyme',
    category: 'dog',
    slug: 'lyme',
    content: 'Borrelia burgdorferi ile kene kaynaklı enfeksiyon; topallık ve ateş yapabilir.\n\nKene profilaksisi ve uygun antibiyotik tedavisi esastır.',
    symptoms: ['Topallık', 'Ateş'],
    treatment: ['Doksisiklin'],
    prevention: ['Kene koruması']
  },
  {
    id: 'mantar',
    title: 'Köpeklerde Mantar Hastalığı',
    category: 'dog',
    slug: 'kopeklerde-mantar-hastaligi',
    content: 'Dermatofitoz; dairesel kellik, pullanma ve kaşıntı yapar.\n\nTopikal/oral antifungaller ve çevresel dezenfeksiyon gerekir.',
    symptoms: ['Kellik halkaları', 'Pullanma'],
    treatment: ['Antifungal tedavi'],
    prevention: ['Dezenfeksiyon']
  },
  {
    id: 'parazit',
    title: 'Parazit',
    category: 'dog',
    slug: 'parazit',
    content: 'İç-dış parazitler anemi, kilo kaybı ve dermatit yapabilir.\n\nAylık profilaksi ve dışkı kontrolleri önerilir.',
    symptoms: ['Kilo kaybı', 'Kaşıntı'],
    treatment: ['Antiparaziter ilaçlar'],
    prevention: ['Profilaksi', 'Hijyen']
  },
  {
    id: 'parvovirus',
    title: 'Parvovirus',
    category: 'dog',
    slug: 'parvovirus',
    content: 'Şiddetli kanlı ishal ve kusma ile seyreden, yavrularda ağır viral hastalık.\n\nYoğun destek tedavisi ve aşılama kritik önemdedir.',
    symptoms: ['Kanlı ishal', 'Kusma', 'Ateş'],
    treatment: ['Sıvı-elektrolit', 'Destek'],
    prevention: ['Aşılama', 'İzolasyon']
  },
  {
    id: 'uyuz',
    title: 'Köpeklerde Uyuz',
    category: 'dog',
    slug: 'kopeklerde-uyuz',
    content: 'Sarcoptes/Demodex akarları yoğun kaşıntı ve deri lezyonları yapar.\n\nAkarisit tedaviler ve sekonder enfeksiyon kontrolü gerekir.',
    symptoms: ['Şiddetli kaşıntı', 'Kabuklanma'],
    treatment: ['Akarisitler'],
    prevention: ['Temasın kısıtlanması', 'Hijyen']
  },
  {
    id: 'kene',
    title: 'Köpeklerde Kene',
    category: 'dog',
    slug: 'kopeklerde-kene',
    content: 'Keneler kan emerek hastalık taşır; düzenli profilaksi şarttır.\n\nVücuttan doğru çıkarma ve çevresel mücadele önemlidir.',
    symptoms: ['Kene tutunması', 'Kaşıntı'],
    treatment: ['Kene uzaklaştırma', 'Profilaksi'],
    prevention: ['Aylık kene koruması']
  },
  {
    id: 'pankreatit',
    title: 'Köpeklerde Pankreatit',
    category: 'dog',
    slug: 'kopeklerde-pankreatit',
    content: 'Pankreas iltihabı; kusma, karın ağrısı ve iştahsızlıkla seyreder.\n\nDüşük yağlı diyet, sıvı tedavisi ve ağrı yönetimi uygulanır.',
    symptoms: ['Kusma', 'Karın ağrısı', 'İştahsızlık'],
    treatment: ['Sıvı', 'Analjezi', 'Diyet'],
    prevention: ['Yağlı gıdadan kaçınma']
  },
  {
    id: 'sagirik',
    title: 'Köpeklerde Sağırlık',
    category: 'dog',
    slug: 'kopeklerde-sagirik',
    content: 'Doğumsal veya yaşa bağlı işitme kaybı görülebilir.\n\nTanıda BAER; yönetimde çevresel uyarlamalar kullanılır.',
    symptoms: ['Çağrıya yanıt azalması'],
    treatment: ['Davranışsal uyarlamalar'],
    prevention: ['Kulak sağlığı']
  },
  {
    id: 'kusma',
    title: 'Köpeklerde Kusma',
    category: 'dog',
    slug: 'kopeklerde-kusma',
    content: 'Çok sayıda nedenle gelişebilir; akut/kronik ayrımı önemlidir.\n\nAntiemetik, mide koruyucu ve nedene yönelik yaklaşım gerekir.',
    symptoms: ['Bulantı', 'Salya'],
    treatment: ['Antiemetik', 'Mide koruyucu'],
    prevention: ['Toksin/yabancı cisimden kaçınma']
  },
  {
    id: 'kabizlik',
    title: 'Köpeklerde Kabızlık',
    category: 'dog',
    slug: 'kopeklerde-kabizlik',
    content: 'Lif yetersizliği, dehidrasyon veya ağrı kabızlığa neden olabilir.\n\nDiyet lifleri, hidrasyon ve gerekirse laksatifler kullanılır.',
    symptoms: ['Zor dışkılama', 'Karın rahatsızlığı'],
    treatment: ['Lif', 'Sıvı', 'Laksatif'],
    prevention: ['Su tüketimi', 'Diyet']
  }
]

export const catDiseases: Disease[] = [
  {
    id: 'kedilerde-ates-nasil-dusurulur',
    title: 'Kedilerde Ateş Nasıl Düşürülür',
    category: 'cat',
    slug: 'kedilerde-ates-nasil-dusurulur',
    content: 'Kedilerde ateş genellikle enfeksiyon, inflamasyon veya ağrıya bağlı bir savunma yanıtıdır. 39.2°C üzeri değerler ateş olarak kabul edilir; halsizlik, iştahsızlık ve saklanma eşlik edebilir.\n\nEvde soğuk uygulama veya insan ilacı kullanmak risklidir. Veteriner değerlendirmesi sonrası nedene yönelik tedavi (sıvı desteği, antibiyotik/antiviral, antiinflamatuvarlar) ile güvenli şekilde düşürülmelidir.',
    symptoms: ['Yüksek ısı', 'Halsizlik', 'İştahsızlık'],
    treatment: ['Nedene yönelik tedavi', 'Sıvı desteği', 'Veteriner kontrolü'],
    prevention: ['Aşılama', 'Parazit önleme', 'Düzenli kontrol']
  },
  {
    id: 'kedilerde-glokom',
    title: 'Kedilerde Glokom',
    category: 'cat',
    slug: 'kedilerde-glokom',
    content: 'Glokom, artmış göz içi basıncıyla optik sinirde hasar ve görme kaybına yol açabilir. Birincil olabilir ya da üveit/katarakt gibi nedenlere ikincil gelişebilir. Gözde büyüme, bulanıklık ve ağrı tipiktir.\n\nTedavi göz içi basıncını düşüren damlalar, ağrı kontrolü ve altta yatan nedenin giderilmesini içerir; ilerleyen olgularda cerrahi gerekebilir.',
    symptoms: ['Gözde büyüme', 'Kızarıklık', 'Işığa hassasiyet'],
    treatment: ['GİB düşürücü damlalar', 'Ağrı kontrolü', 'Cerrahi seçenekler'],
    prevention: ['Düzenli göz muayenesi']
  },
  {
    id: 'kedilerde-hipotermi',
    title: 'Kedilerde Hipotermi: Teşhisi, Sebepleri & Tedavisi',
    category: 'cat',
    slug: 'kedilerde-hipotermi',
    content: 'Hipotermi; soğuğa maruziyet, şok veya yavruluk gibi durumlarda gelişir. Titreme, soğuk deri ve letarji görülebilir.\n\nTedavide kontrollü ısıtma, sıvı-oksijen desteği ve altta yatan nedenin düzeltilmesi esastır. Erken müdahale prognozu iyileştirir.',
    symptoms: ['Titreme', 'Soğuk deri', 'Letarji'],
    treatment: ['Kontrollü ısıtma', 'Sıvı/oksijen desteği'],
    prevention: ['Soğuktan korunma']
  },
  {
    id: 'kedilerde-pire',
    title: 'Kedilerde Pire: Teşhisi, Tedavisi & Sebepleri',
    category: 'cat',
    slug: 'kedilerde-pire',
    content: 'Pireler şiddetli kaşıntı, FAD (pire alerjisi dermatiti) ve anemiye neden olabilir. Ev yaşam döngüsü (yumurta-larva-pupa) nedeniyle tekrarlar gözlenir.\n\nTedavi: güvenli topikal/oral pire ürünleri ve çevresel mücadele. Aylık profilaksi ve yatak-yaşam alanı temizliği tekrarları azaltır.',
    symptoms: ['Kaşıntı', 'Kabuklanma', 'Kıl dökülmesi'],
    treatment: ['Topikal/oral pire ürünleri', 'Çevresel temizlik'],
    prevention: ['Aylık profilaksi', 'Ev hijyeni']
  },
  {
    id: 'kedilerde-gastrit',
    title: 'Kedilerde Gastrit Nedir, Nasıl Anlaşılır ve Tedavi Edilir?',
    category: 'cat',
    slug: 'kedilerde-gastrit',
    content: 'Gastrit; ani diyet değişikliği, yabancı cisim, ilaçlar veya sistemik hastalıklarla tetiklenen mide mukozası iltihabıdır. Kusma, iştahsızlık ve karın rahatsızlığı görülebilir.\n\nTedavi; antiemetik, mide koruyucu, kısa süreli açlık ve uygun diyete dayanır. Nedeni düzeltmek nüksü önler.',
    symptoms: ['Kusma', 'İştahsızlık', 'Karın hassasiyeti'],
    treatment: ['Antiemetik', 'Mide koruyucu', 'Diyet'],
    prevention: ['Kademeli diyet geçişi']
  },
  {
    id: 'kedilerde-kiraz-goz',
    title: 'Kedilerde Kiraz Göz',
    category: 'cat',
    slug: 'kedilerde-kiraz-goz',
    content: 'Üçüncü göz kapağı bezinin prolapsusu, göz köşesinde kırmızı-kabarık kitle ile seyreder. Rahatsızlık ve gözyaşı artışı yapar.\n\nTedavi genellikle bezin yerine dikildiği cerrahi tekniklerle yapılır; tamamen alınması gözyaşı yetersizliği riski taşır.',
    symptoms: ['Göz köşesinde kırmızı kitle', 'Gözyaşı artışı'],
    treatment: ['Cerrahi repozisyon'],
    prevention: ['Travmadan kaçınma']
  },
  {
    id: 'kedilerde-kalp-yetmezligi',
    title: 'Kedilerde Kalp Yetmezliği: Belirtileri, Sebepleri ve Tedavisi',
    category: 'cat',
    slug: 'kedilerde-kalp-yetmezligi',
    content: 'Kalp, dokulara yeterli kanı pompalayamadığında solunum sıkıntısı, halsizlik ve iştahsızlık görülebilir. HCM ve kapak hastalıkları başlıca nedenlerdir.\n\nTedavi; diüretikler, ACE inhibitörleri ve gerekirse antikoagülanlarla semptom kontrolünü hedefler; düşük stres ve kilo yönetimi önerilir.',
    symptoms: ['Hızlı/zor nefes alma', 'Halsizlik'],
    treatment: ['Diüretikler', 'ACE inhibitörleri', 'Antikoagülanlar'],
    prevention: ['Düzenli kardiyak kontrol']
  },
  {
    id: 'kedilerde-kalp-hastaliklari',
    title: 'Kedilerde Kalp Hastalıkları: Belirtileri ve Tedavisi',
    category: 'cat',
    slug: 'kedilerde-kalp-hastaliklari',
    content: 'En yaygın kalp hastalığı HCM’dir. Uzun süre belirtisiz kalabilir; ilerlediğinde hızlı solunum, çabuk yorulma ve iştahsızlık görülür.\n\nTedavi; kalp hızını-kasusunu düzenleyen ilaçlar ve diüretikleri içerir; riskli ırklarda ekokardiyografik tarama önerilir.',
    symptoms: ['Hızlı solunum', 'Egzersiz intoleransı'],
    treatment: ['Kalp ilaçları', 'Diüretikler'],
    prevention: ['Riskli ırklarda tarama']
  },
  {
    id: 'kedilerde-ic-kanama',
    title: 'Kedilerde İç Kanama: Sebepleri, Teşhisi & Tedavisi',
    category: 'cat',
    slug: 'kedilerde-ic-kanama',
    content: 'İç kanama travma, pıhtılaşma bozuklukları veya toksinlerle gelişebilir. Soluk diş etleri, karın şişliği ve halsizlik alarm bulgulardır.\n\nTedavi; sıvı/kan desteği, cerrahi ve nedene yönelik yaklaşımları kapsar.',
    symptoms: ['Soluk diş etleri', 'Karın şişliği', 'Letarji'],
    treatment: ['Sıvı/kan desteği', 'Cerrahi'],
    prevention: ['Travmadan kaçınma', 'Toksin önleme']
  },
  {
    id: 'kedi-aknesi',
    title: 'Kedi Aknesi',
    category: 'cat',
    slug: 'kedi-aknesi',
    content: 'Çene bölgesinde siyah noktalar ve püstüllerle seyreden, genellikle kontakt irritanlar veya hijyenle ilişkili bir durumdur.\n\nTopikal temizlik, uygun antiseptikler ve gerekirse antibiyotikli ürünler kullanılır; plastik kaplardan kaçınmak nüksü azaltır.',
    symptoms: ['Çenede siyah noktalar', 'Kızarıklık', 'Şişlik'],
    treatment: ['Topikal temizlik', 'Antiseptikler'],
    prevention: ['Kap hijyeni', 'Stres azaltma']
  },
  {
    id: 'kedilerde-astim',
    title: 'Kedilerde Astım Nedir, Belirtileri ve Tedavi Süreci',
    category: 'cat',
    slug: 'kedilerde-astim-nedir-belirtileri-ve-tedavi-sureci',
    content: 'Feline astım, hava yollarında inflamasyon ve daralma ile seyreden kronik bir solunum hastalığıdır. Toz ve duman gibi tetikleyiciler atakları alevlendirir.\n\nTedavi kortikosteroid ve bronkodilatörlere, korunma ise alerjen azaltımına dayanır.',
    symptoms: ['Öksürük', 'Hırıltı', 'Nefes darlığı'],
    treatment: ['Kortikosteroid', 'Bronkodilatör'],
    prevention: ['Alerjen azaltımı', 'Kum seçimi']
  },
  {
    id: 'kedilerde-diz-kapagi-cikmasi',
    title: 'Kedilerde Diz Kapağı Çıkması',
    category: 'cat',
    slug: 'kedilerde-diz-kapagi-cikmasi',
    content: 'Patellar luksasyon, diz kapağının yuvasından çıkmasıdır; topallık ve ağrı yapar.\n\nDereceye göre istirahat/analjezi veya cerrahi düzeltme planlanır; kilo kontrolü destekleyicidir.',
    symptoms: ['Topallık', 'Ağrı'],
    treatment: ['Analjezi', 'Ortopedik cerrahi'],
    prevention: ['Kilo yönetimi']
  },
  {
    id: 'kedilerde-fip',
    title: 'Kedilerde FIP Hastalığı (Coronavirus)',
    category: 'cat',
    slug: 'kedilerde-fip',
    content: 'FIP, kedi koronavirüsünün mutasyonuyla ortaya çıkan ciddi bir hastalıktır. Ateş, kilo kaybı ve karında/toraksta sıvı birikimi görülebilir.\n\nTedavi destekleyicidir; antiviral protokoller veteriner kontrolünde değerlendirilir.',
    symptoms: ['Ateş', 'Kilo kaybı', 'Karında şişlik'],
    treatment: ['Destekleyici bakım', 'Antiviral protokoller'],
    prevention: ['Kalabalık ortamları azaltma']
  },
  {
    id: 'kedilerde-bobrek-yetmezligi',
    title: 'Kedilerde Böbrek Yetmezliği',
    category: 'cat',
    slug: 'kedilerde-bobrek-yetmezligi',
    content: 'Kronik böbrek hastalığı yaşlı kedilerde sık; çok su içme, sık idrar ve kilo kaybı görülür.\n\nBöbrek diyeti, sıvı desteği ve bireysel medikal planlarla yönetilir.',
    symptoms: ['Polidipsi', 'Poliüri', 'Kilo kaybı'],
    treatment: ['Böbrek diyeti', 'Sıvı desteği'],
    prevention: ['Yaşlı kedi taraması']
  },
  {
    id: 'kedilerde-fcv',
    title: 'Kedilerde Feline Calicivirus (FCV)',
    category: 'cat',
    slug: 'kedilerde-fcv',
    content: 'ÜSYE bulguları ve ağız ülserleriyle seyreder; tedavi destekleyicidir.\n\nAşılama korunmada etkilidir.',
    symptoms: ['Hapşırık', 'Ağız ülserleri'],
    treatment: ['Destekleyici bakım'],
    prevention: ['Aşılama']
  },
  {
    id: 'feline-panleukopenia',
    title: 'Feline Panleukopenia Hastalığı',
    category: 'cat',
    slug: 'feline-panleukopenia-hastaligi',
    content: 'Yüksek bulaşıcılıkta viral hastalık; şiddetli ishal ve kusmayla seyreder.\n\nYoğun destek tedavisi ve aşılama esastır.',
    symptoms: ['Şiddetli ishal', 'Kusma', 'Ateş'],
    treatment: ['Sıvı-elektrolit', 'Destekleyici bakım'],
    prevention: ['Aşılama', 'İzolasyon']
  },
  {
    id: 'kedilerde-fiv',
    title: 'Kedilerde FIV Hastalığı',
    category: 'cat',
    slug: 'kedilerde-fiv',
    content: 'Bağışıklık zayıflığına yol açan retrovirüs; ısırıkla bulaş yaygındır.\n\nDüzenli kontroller ve enfeksiyonlardan korunma yönetimin temelidir.',
    symptoms: ['Kilo kaybı', 'Tekrarlayan enfeksiyonlar'],
    treatment: ['Destekleyici bakım'],
    prevention: ['Kavga riskini azaltma']
  },
  {
    id: 'kedilerde-goz-sulanmasi',
    title: 'Kedilerde Göz Sulanması',
    category: 'cat',
    slug: 'kedilerde-goz-sulanmasi',
    content: 'Alerji, irritasyon veya viral etkenler akıntı yapabilir.\n\nTemizlik ve uygun damlalarla yönetilir.',
    symptoms: ['Akıntı', 'Kızarıklık'],
    treatment: ['Göz damlaları', 'Temizlik'],
    prevention: ['Toz/dumandan kaçınma']
  },
  {
    id: 'kedilerde-hipertiroidizm',
    title: 'Kedilerde Hipertiroidizm Hastalığı',
    category: 'cat',
    slug: 'kedilerde-hipertiroidizm',
    content: 'Kilo kaybı, iştah artışı ve huzursuzlukla seyreder.\n\nAntitiroid ilaçlar, I-131 ve cerrahi seçenekler mevcuttur.',
    symptoms: ['Kilo kaybı', 'Polifaji'],
    treatment: ['Antitiroid', 'I-131', 'Cerrahi'],
    prevention: ['Yaşlı kedi taraması']
  },
  {
    id: 'kedilerde-hipertrofik-kardiyomiyopati',
    title: 'Kedilerde Hipertrofik Kardiyomiyopati',
    category: 'cat',
    slug: 'kedilerde-hipertrofik-kardiyomiyopati',
    content: 'Kalp kasında kalınlaşma ile solunum sıkıntısı görülebilir.\n\nEkokardiyografi tanıda altın standarttır.',
    symptoms: ['Hızlı solunum', 'Letarji'],
    treatment: ['Kalp ilaçları', 'Diüretikler'],
    prevention: ['Riskli ırklarda tarama']
  },
  {
    id: 'kedilerde-idrar-yolu-enfeksiyonu',
    title: 'Kedilerde İdrar Yolu Enfeksiyonu',
    category: 'cat',
    slug: 'kedilerde-idrar-yolu-enfeksiyonu',
    content: 'Sık ve zor idrar, bazen kanla seyreder; bakteriyel enfeksiyon ya da kristaller eşlik edebilir.\n\nKültüre göre antibiyotik ve diyet/su artırımı önerilir.',
    symptoms: ['Sık idrar', 'Zorlanma'],
    treatment: ['Antibiyotik', 'Diyet/su artırımı'],
    prevention: ['Su tüketimi', 'Uygun diyet']
  },
  {
    id: 'kedilerde-ishal',
    title: 'Kedilerde İshal',
    category: 'cat',
    slug: 'kedilerde-ishal',
    content: 'Diyet değişikliği, parazit veya viral nedenlerle sulu dışkı oluşur.\n\nDiyet düzenlemesi, probiyotik ve gerekirse ilaçlarla tedavi edilir.',
    symptoms: ['Sulu dışkı', 'Karın gurultusu'],
    treatment: ['Diyet', 'Probiyotik'],
    prevention: ['Parazit kontrolü']
  },
  {
    id: 'kedilerde-katarakt',
    title: 'Kedilerde Katarakt',
    category: 'cat',
    slug: 'kedilerde-katarakt',
    content: 'Lens bulanıklığı görmeyi azaltır; yaş veya diyabetle ilişkili olabilir.\n\nFakoemülsifikasyon cerrahisi uygun olgularda etkilidir.',
    symptoms: ['Lens bulanıklığı', 'Görme azalması'],
    treatment: ['Cerrahi'],
    prevention: ['Sistemik kontrol']
  },
  {
    id: 'kedilerde-kuduz',
    title: 'Kedilerde Kuduz Hastalığı',
    category: 'cat',
    slug: 'kedilerde-kuduz',
    content: 'Zoonotik ve ölümcül viral hastalık; davranış değişikliği ve felç görülebilir.\n\nAşılama ve temas sonrası profilaksi şarttır.',
    symptoms: ['Davranış değişimi', 'Felç'],
    treatment: ['Destekleyici bakım'],
    prevention: ['Aşılama']
  },
  {
    id: 'kedilerde-kusma',
    title: 'Kedilerde Kusma',
    category: 'cat',
    slug: 'kedilerde-kusma',
    content: 'Gastrit, yabancı cisim veya toksinlere bağlı gelişebilir.\n\nAntiemetik, mide koruyucu ve diyet önerilir.',
    symptoms: ['Bulantı', 'Salya'],
    treatment: ['Antiemetik', 'Mide koruyucu'],
    prevention: ['Toksinlerden kaçınma']
  },
  {
    id: 'kedilerde-leishmaniasis',
    title: 'Kedilerde Leishmaniasis (Layşmanyaz)',
    category: 'cat',
    slug: 'kedilerde-leishmaniasis',
    content: 'Vektörle bulaşan paraziter hastalık; deri lezyonları ve kilo kaybı yapabilir.\n\nTedavi antiprotozoal protokollerle veteriner kontrolünde yürütülür.',
    symptoms: ['Deri lezyonları', 'Kilo kaybı'],
    treatment: ['Antiprotozoal tedavi'],
    prevention: ['Vektör mücadelesi']
  },
  {
    id: 'kedilerde-lyme',
    title: 'Kedilerde Lyme Hastalığı',
    category: 'cat',
    slug: 'kedilerde-lyme',
    content: 'Kene kaynaklı Borrelia enfeksiyonu kedilerde nadirdir; ateş ve topallık yapabilir.\n\nTedavi uygun antibiyotiklerle yapılır.',
    symptoms: ['Ateş', 'Topallık'],
    treatment: ['Antibiyotik'],
    prevention: ['Kene profilaksisi']
  },
  {
    id: 'kedilerde-ucuncu-goz-kapagi',
    title: 'Kedilerde Üçüncü Göz Kapağı',
    category: 'cat',
    slug: 'kedilerde-ucuncu-goz-kapagi',
    content: 'Üçüncü göz kapağının belirginleşmesi altta yatan sorunların habercisi olabilir.\n\nNedene yönelik tedavi esastır.',
    symptoms: ['Üçüncü kapak görünürlüğü'],
    treatment: ['Nedene yönelik tedavi'],
    prevention: ['Düzenli kontrol']
  },
  {
    id: 'kedi-losemi-hastaligi-felv',
    title: 'Kedi Lösemi Hastalığı (FeLV)',
    category: 'cat',
    slug: 'kedi-losemi-hastaligi-felv',
    content: 'FeLV bağışıklığı zayıflatır; kilo kaybı ve tekrarlayan enfeksiyonlarla seyreder.\n\nAşılama ve pozitif kedilerin ayrıştırılması bulaşmayı azaltır.',
    symptoms: ['Kilo kaybı', 'Enfeksiyonlara yatkınlık'],
    treatment: ['Destekleyici bakım'],
    prevention: ['Aşılama', 'Test']
  },
  {
    id: 'kedilerde-mantar-hastaligi',
    title: 'Kedilerde Mantar Hastalığı',
    category: 'cat',
    slug: 'kedilerde-mantar-hastaligi',
    content: 'Dermatofitoz zoonotik olabilir; dairesel kellik ve pullanma tipiktir.\n\nTopikal/oral antifungaller ve çevre dezenfeksiyonu birlikte yürütülmelidir.',
    symptoms: ['Dairesel kellik', 'Pullanma'],
    treatment: ['Antifungaller'],
    prevention: ['Dezenfeksiyon']
  },
  {
    id: 'kedilerde-paraziter-hastaliklar',
    title: 'Kedilerde Paraziter Hastalıklar',
    category: 'cat',
    slug: 'kedilerde-paraziter-hastaliklar',
    content: 'İç ve dış parazitler anemi ve dermatite neden olabilir.\n\nAylık profilaksi ve hijyen koruyucudur.',
    symptoms: ['Kaşıntı', 'Kilo kaybı'],
    treatment: ['Antiparaziter ilaçlar'],
    prevention: ['Profilaksi', 'Hijyen']
  },
  {
    id: 'kedilerde-diyabet',
    title: 'Kedilerde Diyabet',
    category: 'cat',
    slug: 'kedilerde-diyabet',
    content: 'İnsülin eksikliği/direnciyle gelişir; çok su içme, çok idrar ve kilo kaybı yapar.\n\nİnsülin, diyet ve glukoz takibi tedavinin temelidir.',
    symptoms: ['Polidipsi', 'Poliüri'],
    treatment: ['İnsülin', 'Diyet'],
    prevention: ['Kilo yönetimi']
  },
  {
    id: 'kedi-nezlesi-gribi',
    title: 'Kedi Nezlesi (Gribi)',
    category: 'cat',
    slug: 'kedi-nezlesi-gribi',
    content: 'Üst solunum yolu enfeksiyonları hapşırık, akıntı ve ateşle seyreder.\n\nAşılama ve stresin azaltılması korunmada etkilidir.',
    symptoms: ['Hapşırık', 'Burun akıntısı'],
    treatment: ['Destekleyici bakım'],
    prevention: ['Aşılama']
  },
  {
    id: 'kedilerde-toksoplazma',
    title: 'Kedilerde Toksoplazma',
    category: 'cat',
    slug: 'kedilerde-toksoplazma',
    content: 'Toxoplasma gondii çoğu kedide hafif seyreder; kum hijyeni ve çiğ etten kaçınma korunmada etkilidir.',
    symptoms: ['Hafif ateş', 'Letarji'],
    treatment: ['Antiprotozoal ilaçlar'],
    prevention: ['Kum kabı hijyeni']
  }
]

export const allDiseases = [...dogDiseases, ...catDiseases]
